export enum Field {
  Email = 'email',
  UniqueCode = 'uniqueCode',
  FullName = 'fullName',
  Swift = 'swift',
  Iban = 'iban',

  OtherInformation = 'otherInformation',
}

export type FormModel = {
  [Field.Email]: string
  [Field.UniqueCode]: string
  [Field.FullName]: string
  [Field.Iban]: string
  [Field.Swift]: string
  [Field.OtherInformation]: string
}
